export const environment = {
	production: false,
	PATH_FILES: 'https://images.weserv.nl/?url=http://190.102.134.78/ciptech-files',
	PATH_APP: 'http://190.102.134.78/ciptech',
	EMAIL_BASE: { Email: 'sistemas.cipsa@cipsa.com.pe', Nombre: 'CIPTECH TEST' },
	TOKEN_PUBLIC: 'pk_test_wgKJ9DEujFG9g9kn',
	URL_LR: 'https://reclamos-test.ciptech.pe/',
	EMAIL_DESTINATARIOS: [{ Email: 'helpdesk.ciptech@cipsa.com.pe', Nombre: 'Info CIPTECH' }],
	IGV_VALOR: 0.18,
	DIAS_RECOJO: 3,
	LIM_MINIMO_PRODUCTOS: 1,
	MINIMO_COMPRA_DOL: 1,
	MAXIMO_COMPRA_DOL: 5000,
	PREVIOS_TOKEN_REFRESH_MIN: 2,
	PREVIOS_TOKEN_REFRESH_SEG: 30,
	IDLE_TIMEOUT_MIN: 30,
	IDLE_TIMEOUT_SEG: 0,

	FILE_VAR: {
		EXTENSIONS: 'pdf|doc|docx|xls|xlsx|xlsm|csv|jpg|jpeg|png|gif|bmp|webp|zip|rar|7z|mp4|mov|avi|mkv|wmv|flv|webm|m4v|mpeg|mpg',
		MAX_ARCHIVOS: 5,
		MAX_PESO: {
			GB: 0,
			MB: 10,
			KB: 0
		}
	},

	HORA_FIN_ENTREGA: { hora: 16, minuto: 0 }
};
